//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapGetters } from 'vuex'
import { specialCharsDecode } from '../../components/helpers.js'
import { EventBus } from '../../EventBus/EventBus.js'

import ReportCheckListActuality from './ReportCheckList/ReportCheckListActuality.vue'
import ReportTitle from './ReportTitle.vue'
import ReportBody from './ReportBody.vue'
import ReportButtons from './ReportButtons.vue'
import ReportRushLabel from './ReportRushLabel.vue'
import ReportContent from './ReportContent/ReportContent.vue'
import reportContentStore from './ReportContent/reportContentStore.js'

export default {
  components: {
    ReportBody,
    ReportCheckListActuality: ReportCheckListActuality,
    ReportTitle: ReportTitle,
    ReportButtons,
    ReportRushLabel,
    ReportContent
  },
  provide () {
    return { contentStoreModule: 'reportContent' }
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    reportTitle: {
      type: String,
      default () {
        return ''
      }
    },
    taskStatus: {
      default: '',
      type: String
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObject: {
      type: Object,
      default: null
    },
    insideReportRoads: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      headerHeight: 0,
      modalActualityOpened: false,
      modalActualityContractorOpened: false,
      reportContentOpen: false
    }
  },
  computed: {
    docsHeaderFixed: function () {
      return this.$store.getters.getUserSetting('ui.common.docsHeaderFixed', true)
    },
    actualityFullScreen: function () {
      return this.mobileDevice || this.actualityWindowFullScreen
    },
    isAudit: function () {
      return !!(this.report.audit || this.report.auditObject)
    },
    mobileDevice: function () {
      // !document.body.classList.contains('desktop')
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    mobile: function () { // mobile view selected
      return this.$store.getters.getUser.view === 'mobile'
    },
    showMobileView: function () { // executor simple wiew
      if (this.mobile) {
        // TODO отдельная настройка выбора представления для отчёта при наличии доступа к обоим вариантам (mobile и dispatcher)
        //
        // if (!this.mobileDevice) {
        //   const availableViews = this.$store.getters.getUser.availableViews
        //   return !(availableViews && availableViews.contains('dispatcher')) // отображаем полную версию для пользователя с доступом к ней, если открыт десктопный интерфейс ?
        // }
        return true
      }
      return false
    },
    showExecutorsSections: function () {
      if (!this.report.isFieldIncluded('executorSection')) {
        return false
      }
      return (this.reportRoles.roleContractorDispatcher || this.reportRoles.roleDispatcherOrHigher || this.reportRoles.roleReportCheckerOrHigher) && !this.insideReportRoads
    },
    showExecutorCheckList: function () {
      // TODO нужны более точные условия
      if (this.reportRoles.roleExecutor) {
        if (this.reportRoles.roleDispatcherOrHigher) {
          return this.taskStatus == 'BS4' || this.taskStatus == 'BS5' || this.taskStatus == 'BS6' || this.taskStatus == 'BS14' || this.taskStatus == 'BS15'
        } else {
          return true
        }
      } else if (this.reportRoles.roleContractorDispatcher) {
        if (this.report.stateId != 'PR7') {
          return true
        }
      }
      return false
    },
    applicantDescription: function () {
      if (this.report && this.report.applicantDescr && this.report.applicantDescr.length) {
        return specialCharsDecode(this.report.applicantDescr)
      }
      return null
    },
    ...mapGetters({
      getDocumentScrollTop: 'getDocumentScrollTop',
      actualityWindowFullScreen: 'getActualityWindowFullScreen'
    })
  },
  watch: {
    'report.id': function (reportId) {
      this.initializeReportContentSession(reportId)
    }
  },
  destroyed: function () {
    if (this.reportContentNavigateTimer) {
      clearTimeout(this.reportContentNavigateTimer)
      this.reportContentNavigateTimer = null
    }
    if (!this.$store.state.reportContent) {
      return
    }
    this.releaseReportContentInstance().then(() => {
      const reportContentState = this.$store.state.reportContent
      if (reportContentState && reportContentState.instancesCount === 0) {
        this.$store.unregisterModule('reportContent')
      }
    })
  },
  created: function () {
    if (!this.$store.state.reportContent) {
      this.$store.registerModule('reportContent', reportContentStore)
    }
    this.retainReportContentInstance()
    this.initializeReportContentSession(this.report && this.report.id)
  },
  mounted: function () {
    setTimeout(() => {
      const scrollReportBody = this.$refs.scrollReportBody
      if (scrollReportBody) {
        scrollReportBody.setScrollPosition('vertical', this.getDocumentScrollTop)
      }
      this.setDocumentScrollTop(0)
    }, 500)

    EventBus.$on('report-updated', this.onReportUpdated)
  },
  beforeDestroy: function () {
    EventBus.$off('report-updated', this.onReportUpdated)
  },
  methods: {
    ...mapActions({
      setDocumentScrollTop: 'setDocumentScrollTop',
      initializeReportContentSession: 'reportContent/initializeSession',
      retainReportContentInstance: 'reportContent/retainInstance',
      releaseReportContentInstance: 'reportContent/releaseInstance'
    }),
    saveReportScrollPosition: function () {
      const scrollReportBody = this.$refs.scrollReportBody
      if (scrollReportBody && typeof scrollReportBody.getScrollPosition === 'function') {
        const scrollPosition = scrollReportBody.getScrollPosition()
        this.setDocumentScrollTop(scrollPosition)
      }
    },
    restoreReportScrollPosition: function () {
      const scrollReportBody = this.$refs.scrollReportBody
      if (scrollReportBody && typeof scrollReportBody.setScrollPosition === 'function') {
        scrollReportBody.setScrollPosition('vertical', this.getDocumentScrollTop || 0)
      }
    },
    openReportContent: function () {
      if (this.reportContentOpen) {
        return
      }
      if (!this.showMobileView) {
        this.saveReportScrollPosition()
      }
      this.reportContentOpen = true
      if (!this.showMobileView) {
        this.$nextTick(() => {
          this.restoreReportScrollPosition()
        })
      }
    },
    closeReportContent: function () {
      if (!this.reportContentOpen) {
        return
      }
      if (!this.showMobileView) {
        this.saveReportScrollPosition()
      }
      this.reportContentOpen = false
      if (!this.showMobileView) {
        this.$nextTick(() => {
          this.restoreReportScrollPosition()
        })
      }
    },
    onReportContentNavigate: function (sectionId) {
      if (this.reportContentNavigateTimer) {
        clearTimeout(this.reportContentNavigateTimer)
      }
      if (this.showMobileView) {
        this.reportContentOpen = false
      }
      this.$nextTick(() => {
        this.reportContentNavigateTimer = setTimeout(() => {
          this.reportContentNavigateTimer = null
          const el = document.getElementById(sectionId)
          if (!el) {
            return
          }
          const scrollArea = this.$refs.scrollReportBody
          if (
            scrollArea &&
            typeof scrollArea.getScrollTarget === 'function' &&
            typeof scrollArea.setScrollPosition === 'function'
          ) {
            const container = scrollArea.getScrollTarget()
            if (container) {
              const offset = container.scrollTop +
                el.getBoundingClientRect().top -
                container.getBoundingClientRect().top
              scrollArea.setScrollPosition('vertical', Math.max(0, offset), 300)
              return
            }
          }
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 450)
      })
    },
    openModalActuality: function (e) {
      this.modalActualityOpened = true
      this.modalActualityContractorOpened = false
    },
    openModalActualityContractor: function (e) {
      this.modalActualityContractorOpened = true
      this.modalActualityOpened = false
    },
    closeModalActuality: function (e) {
      this.modalActualityOpened = false
    },
    closeModalActualityContractor: function (e) {
      this.modalActualityContractorOpened = false
    },
    validate: function (action) {
      let valid = true
      const reportBodyCmp = this.$refs.refReportBody
      if (reportBodyCmp) {
        if (reportBodyCmp.$refs.project) {
          valid &= reportBodyCmp.$refs.project.validate(action)
        }
        if (reportBodyCmp.$refs.executorSection) {
          valid &= reportBodyCmp.$refs.executorSection.validate(action)
        }
      }
      return valid
    },
    onStartSaveChanges: function () {
      const scrollReportBody = this.$refs.scrollReportBody
      if (scrollReportBody) {
        const scrollPosition = scrollReportBody.getScrollPosition()
        this.setDocumentScrollTop(scrollPosition)
      }
    },
    isImage: function (str) {
      return str.startsWith('image/')
    },
    onDefaultRemark: function (remark) {
      this.$emit('default-remark', remark)
    },
    onReportUpdated: function () {
      this.$emit('report-updated')
    }
  }
}

